import React from 'react';
import { MenuItem, Select, Button } from '@material-ui/core';
import moment from 'moment';
import './Custom-Status-List.scss';
import { ALL_STATUS_COLOR } from '../../../constants/DashboardConst';

const CustomStatusList = (props) => {
  const {
    dropdownList,
    filterList,
    idType,
    countType,
    name,
    duration,
    selectedValue,
    handleStatusChange,
  } = props;

  const getDurationWithTreatment = (selectedItem) => {
    if (idType === 'restaurantId') {
      const startTime = selectedItem.reserveFrom;
      const endTime = selectedItem.reserveUntil;
      return `${startTime} - ${endTime}  ${
        selectedItem.orderStatus === 'Scheduled' ? '-' + selectedItem.exposure : ''
      }`;
    } else {
      const startTime = moment(selectedItem.scheduledTime, 'HH:mm').format('hh:mm A');
      const endTime = moment(startTime, 'HH:mm');
      return `${startTime} - ${endTime}  ${
        selectedItem.orderStatus === 'New Request' ? '-' + selectedItem.items[0].name : ''
      }`;
    }
  };

  const getRequest = (selectedItem) => {
    switch (idType) {
      case 'spaId':
        if (selectedItem.orderStatus === 'New Request')
          return `Requested on ${moment(selectedItem.scheduledDate).format('Do MMM, hh:mm A')}`;
        if (selectedItem.orderStatus !== 'New Request') return selectedItem.items[0].name;
        break;
      case 'restaurantId':
        if (selectedItem.orderStatus === 'New Request')
          return `Requested on ${moment(selectedItem.date).format('Do MMM, hh:mm A')}`;
        if (selectedItem.orderStatus !== 'New Request') return selectedItem.exposure;
        break;
      default:
        break;
    }
  };

  const setBackgroundColor = (selectedItem) => {
    const cuttentStatus = ALL_STATUS_COLOR.find((status) => status.id === selectedItem.orderStatus);
    if (cuttentStatus) return cuttentStatus.color;
  };

  return (
    <div className='custom-dashboard-status-list'>
      <div className='d-flex flex-wrap gap-2 col-12 align-items-baseline'>
        <div className='col'>
          <Button
            className='py-2 dropdown-button'
            variant='outlined'
            color='secondary'
            size='medium'
          >
            <Select
              value={selectedValue}
              onChange={(e) => handleStatusChange(e.target.value)}
              className='custom-dashboard-status-list-select'
              MenuProps={{ className: 'status-dropdown-list' }}
            >
              {dropdownList?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </Button>
        </div>
        <div className='col'>
          <p className='custom-dashboard-status-list-count text-nowrap'>
            {('0' + filterList.length).slice(-2)} {countType}
          </p>
        </div>
        <div className='col-md-12 mt-4 form-scroll scroll-styled'>
          {filterList.length > 0 ? (
            <>
              {filterList.map((list, ndx) => (
                <div className='custom-dashboard-status-list-box' key={ndx}>
                  <div
                    className='custom-dashboard-status-list-box-color'
                    style={{ backgroundColor: setBackgroundColor(list) }}
                  ></div>
                  <div className='p-2'>
                    <p className='custom-dashboard-status-list-box-name'>{list[name]}</p>
                    {duration && (
                      <p className='custom-dashboard-status-list-box-duration'>
                        {getDurationWithTreatment(list)}
                      </p>
                    )}
                    <p className='custom-dashboard-status-list-box-requested-date-time'>
                      {getRequest(list)}
                    </p>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <p className='no-activity'>No {countType} available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomStatusList;
